export default "__VITE_ASSET__BDQ8Zv6c__"